// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"740":"16ad494a","751":"f6c61cbb"}[chunkId] + ".chunk.css";
};